// Mapping of CLABE prefixes (3 digits) to bank names.
// Source: CNBV catalog (trimmed for current needs).
export const BANK_CODES: Record<string, string> = {
  "002": "Banamex",
  "006": "Bancomext",
  "009": "Banobras",
  "012": "BBVA Bancomer",
  "014": "Santander",
  "019": "Banjercito",
  "021": "HSBC",
  "030": "Banco del Bajío",
  "032": "IXE",
  "036": "Inbursa",
  "037": "Interacciones",
  "042": "Mifel",
  "044": "Scotiabank",
  "058": "Banregio",
  "059": "Invex",
  "060": "Bansi",
  "062": "Afirme",
  "072": "Banorte",
  "102": "The Royal Bank",
  "103": "American Express",
  "106": "BAMSA",
  "108": "Bank of Tokyo-MUFG",
  "110": "JP Morgan",
  "112": "BMonex",
  "113": "Ve por Más",
  "116": "ING",
  "124": "Deutsche Bank",
  "126": "Credit Suisse",
  "127": "Azteca",
  "128": "Autofin",
  "129": "Barclays",
  "130": "Compartamos",
  "131": "Banco Famsa",
  "132": "BMULTIVA",
  "133": "Actinver",
  "134": "Wal-Mart",
  "135": "NAFIN",
  "136": "InterBanco",
  "137": "BanCoppel",
  "138": "ABC Capital",
  "139": "UBS Bank",
  "140": "Consubanco",
  "141": "Volkswagen Bank",
  "143": "CIBanco",
  "145": "Banco Base",
  "166": "Bansefi",
  "168": "Sociedad Hipotecaria Federal",
  "600": "Monex Casa de Bolsa",
  "601": "GBM",
  "602": "Masari",
  "605": "Value",
  "606": "Estructuradores",
  "607": "Tiber",
  "608": "Vector",
  "610": "B y B",
  "614": "Accival",
  "615": "Merrill Lynch",
  "616": "Finamex",
  "617": "Valmex",
  "618": "Unica",
  "619": "MAPFRE",
  "620": "Profuturo",
  "621": "CB Actinver",
  "622": "Operadora Actinver",
  "623": "Skandia",
  "626": "CB Deutsche",
  "627": "Zurich",
  "628": "Zurich Vida",
  "629": "Su Casita",
  "630": "CB Intercam",
  "631": "CI Bolsa",
  "632": "Bulltick",
  "633": "Sterling",
  "634": "Fincomún",
  "636": "HDI Seguros",
  "637": "Order",
  "638": "Akala",
  "640": "CB JPMorgan",
  "642": "Operadora Reforma",
  "646": "STP",
  "647": "Telecomm",
  "648": "Evercore",
  "649": "Skandia Operadora",
  "651": "Seguros Monterrey",
  "652": "Asea",
  "653": "Kuspit",
  "655": "Sofiexpress",
  "656": "Unagra",
  "659": "Opciones Empresariales",
  "670": "Libertad",
  "902": "Indeval",
  "999": "N/A",
};

export const detectBankByClabe = (clabe: string): string | null => {
  const prefix = clabe.slice(0, 3);
  return BANK_CODES[prefix] || null;
};
